import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";
import Button from "../../atoms/Button";
import Table from "../../atoms/Table";
import { fetchAvailableCreditValuation } from "../../../utils/api/getReports";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import arrow from "../../../assets/svgs/downarrow.svg";
import Pagination from "../../atoms/Pagination";
import SpecificTimePeriod from "./SpecificTimePeriod";
import Registries from "../ReportsTransactionsFilter/RegistriesFilter";
import CountrySelector from "../ReportsTransactionsFilter/Countries";
import Category from "../ReportsTransactionsFilter/Category";

const tableHeader = [
  "Project Name",
  "Project ID",
  "Count",
  "Total Count",
  "Total Credits",
];

const options = [
  { label: "This Week", value: "this-week" },
  { label: "Last Week", value: "last-week" },
  { label: "This Month", value: "this-month" },
  { label: "Last Month", value: "last-month" },
  { label: "Select Specific Time Period", value: "specificTimePeriod" },
];

const selectToken = [
  { label: "Gold", value: "Gold" },
  { label: "Silver", value: "Silver" },
  { label: "Bronze", value: "Bronze" },
];

const FilterComponent = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [openTable, setOpenTable] = useState(false);
  const [selectedToken, setSelectedToken] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedRegistryId, setSelectedRegistryId] = useState("");
  
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedRegistry, setSelectedRegistry] = useState("");
  const [tableData, setTableData] = useState([]);
  // const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const limit = 10;

  const handleSelectedToken = (e) => {
    setSelectedToken(e.target.value);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleCountryChange = (country) => {
    setSelectedCountry(country);
  };

  const handleRegistryChange = (registry) => {
    setSelectedRegistry(registry);
  };

  const handleSelectedTimePeriod = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    updateDates(value);
  };
  const updateDates = (value) => {
    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (value) {
      case "thisWeek":
        const dayOfWeek = today.getDay();
        const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        start = new Date(today.setDate(diff));
        end = new Date(today.setDate(diff + 6));
        break;
      case "lastWeek":
        const lastWeekStart = new Date();
        const lastWeekEnd = new Date();
        lastWeekStart.setDate(today.getDate() - today.getDay() - 6);
        lastWeekEnd.setDate(today.getDate() - today.getDay());
        start = lastWeekStart;
        end = lastWeekEnd;
        break;
      case "thisMonth":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "lastMonth":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        start = "";
        end = "";
    }

    setStartDate(start ? start.toISOString().split("T")[0] : "");
    setEndDate(end ? end.toISOString().split("T")[0] : "");
  };

  const handleSubmit = async (page = 1) => {
    setLoading(true);
    setError("");

    const durationValue =
      selectedOption === "specificTimePeriod" ? "" : selectedOption;

    const apiParams = {
      duration: durationValue,
      fromDate: startDate,
      toDate: endDate,
      category: selectedCategoryId,
      registry: selectedRegistryId,
      location: selectedCountry,
      token_type: selectedToken,
      page  ,  
      limit 
    };

    try {
      const data = await fetchAvailableCreditValuation(apiParams, ()=>{
        setError("Failed to fetch Available Credit Valuation");
      });
      const formattedData = data.map((project) => [
        project.projectDetails[0].project_name,
        project.projectDetails[0].project_id,
        project.valuation,
        project.valuation,
        project.number_Of_Credits,
      ]);
      setTableData(formattedData);
      // setDisplayData(formattedData.slice(0, limit));
      setOpenTable(true);
      // setCurrPage(1);
    } catch (err) {
      setError("Failed to fetch Available Credit Valuation");
      console.error("Error fetching Available Credit Valuation:", err);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      tableData.map((row, index) =>
        tableHeader.reduce(
          (acc, header, idx) => ({
            ...acc,
            [header]: row[idx],
          }),
          {}
        )
      )
    );
    const getMaxColWidth = (colIndex) => {
      let maxColWidth = tableHeader[colIndex]
        ? tableHeader[colIndex].toString().length
        : 10;
      tableData.forEach((row) => {
        const cellValue = row[colIndex] ? row[colIndex].toString() : "";
        maxColWidth = Math.max(maxColWidth, cellValue.length);
      });

      return maxColWidth + 2;
    };

    worksheet["!cols"] = tableHeader.map((_, colIndex) => ({
      wch: getMaxColWidth(colIndex),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "valuationreport");
    XLSX.writeFile(workbook, "Valuation Report.xlsx");
  };
  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Valuation Report", 14, 20);
    doc.autoTable({
      startY: 30,
      head: [tableHeader],
      body: tableData,
    });
    doc.save("valuationreport.pdf");
  };

  const totalPages = (tableData.length === 10 ?currPage+1 :currPage) ;

  const onNext = () => {
    if (currPage < totalPages) {
      const nextPage = currPage + 1;
      // const startIdx = (nextPage - 1) * limit;
      // const endIdx = startIdx + limit;
      // setDisplayData(tableData.slice(startIdx, endIdx));
      setCurrPage(nextPage);
      handleSubmit(nextPage);
    }
  };

  const onPrev = () => {
    if (currPage > 1) {
      const prevPage = currPage - 1;
      // const startIdx = (prevPage - 1) * limit;
      // const endIdx = startIdx + limit;
      // setDisplayData(tableData.slice(startIdx, endIdx));
      setCurrPage(prevPage);
      handleSubmit(prevPage);

    }
  };

  return (
    <div className="bg-gray-100">
      <div className="w-full bg-white text-4xl px-7 rounded-2xl py-5">
        <p className="text-xs text-gray-500">Time Period</p>
        <RadioGroup options={options} onChange={handleSelectedTimePeriod} />
        {selectedOption === "specificTimePeriod" && (
          <div className="py-4">
            <p className="text-xs text-gray-500">Time Period</p>
            <SpecificTimePeriod
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
        )}
        <div className="py-2">
          <hr />
          <div className="pt-2 pb-6 flex gap-6">
            <div className="flex flex-col">
              <label
                htmlFor="category"
                className="text-base font-medium px-1 my-2"
              >
                Category
              </label>
              <Category
                selectedCategory={selectedCategory}
                onSelectCategory={handleCategoryChange}
                onSelectKey={setSelectedCategoryId}
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="category"
                className="text-base font-medium px-1 my-2"
              >
                Country
              </label>
              <CountrySelector
                selectedCountry={selectedCountry}
                onSelectCountry={handleCountryChange}
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="registry"
                className="text-base font-medium px-1 my-2"
              >
                Registry
              </label>
              <Registries
                selectedRegistry={selectedRegistry}
                onCheckRegistry={handleRegistryChange}
                onSelectKey={setSelectedRegistryId}
              />
            </div>
          </div>
          <hr />
        </div>
        <label htmlFor="" className="text-base font-medium  my-2">
          Token Category
        </label>
        <RadioGroup options={selectToken} onChange={handleSelectedToken} />
        <div className="flex gap-4 py-5">
          <Button
            color={"blue"}
            varient={"primary"}
            className="text center w-80 py-2 text-white text-xl font-normal "
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Loading..." : "Submit"}
          </Button>
          <Button
            color={"lightblue"}
            varient={"primary"}
            className="text center w-80 py-2 text-blue-800 text-xl font-normal "
            onClick={() => setOpenTable(false)}
          >
            Cancel
          </Button>
        </div>
        {error && <p className="text-red-500">{error}</p>}
      </div>
      {openTable && tableData.length > 0 && (
        <div className="w-full py-5 mt-4 pr-8">
          <div className="flex justify-end gap-5 pb-3 pr-6">
            <Button
              color={"blue_800"}
              varient={"primary"}
              className={
                "text-white flex justify-center items-center px-9 text-[9px] py-2 font-bold"
              }
              onClick={downloadPDF}
            >
              <img src={arrow} alt="SVG icon" className="w-2.5 h-2.5 mr-1" />
              Pdf
            </Button>
            <Button
              color={"blue_800"}
              varient={"primary"}
              className={
                "text-white flex justify-center items-center px-8 text-[9px] py-2 font-bold"
              }
              onClick={downloadExcel}
            >
              <img src={arrow} alt="icon" className="w-2.5 h-2.5 mr-2" />
              Excel
            </Button>
          </div>
          <div className="w-full bg-white text-4xl px-7 rounded-2xl py-5 my-4">
            <Table data={tableData} headerData={tableHeader} />
          </div>
          {totalPages > 1 && (
            <Pagination
              currPage={currPage}
              onNext={onNext}
              onPrev={onPrev}
              totalPages={totalPages}
            />
          )}
        </div>
      )}
      {openTable && tableData.length === 0 && (
        <div className="text-center text-xl py-4">No data found.</div>
      )}
    </div>
  );
};

export default FilterComponent;
